// extracted by mini-css-extract-plugin
module.exports = {"solutions_nav":"solutionsNav_solutions_nav__YYSUm","solutions_mobilenav":"solutionsNav_solutions_mobilenav__7avcL"};